import AjaxFetchService from './ajax-fetch';

/**
 * @deprecated
 *
 * DO NOT USE. This service is a temporary solution while all references to the old ajax service are removed.*
 */

export default class AjaxService extends AjaxFetchService {}
